// Registriert `src/service-worker.js` - aber nur im Produktions-Build.
//
// Im Entwicklungsbetrieb liefert der CRA-Dev-Server die Datei gar nicht aus;
// ein registrierter Worker wuerde dort ausserdem staendig veraltete Bundles
// ausliefern und das Arbeiten unnoetig erschweren.

const isLocalhost = Boolean(
  window.location.hostname === 'localhost' ||
    window.location.hostname === '[::1]' ||
    window.location.hostname.match(/^127(?:\.(?:25[0-5]|2[0-4]\d|\d{1,2})){3}$/)
);

export function register(config) {
  if (process.env.NODE_ENV !== 'production' || !('serviceWorker' in navigator)) return;

  const publicUrl = new URL(process.env.PUBLIC_URL, window.location.href);
  // Ein Worker kann nur Adressen desselben Origin beantworten.
  if (publicUrl.origin !== window.location.origin) return;

  window.addEventListener('load', () => {
    const swUrl = `${process.env.PUBLIC_URL}/service-worker.js`;

    if (isLocalhost) {
      checkValidServiceWorker(swUrl, config);
    } else {
      registerValidSW(swUrl, config);
    }
  });
}

function registerValidSW(swUrl, config) {
  navigator.serviceWorker
    .register(swUrl)
    .then((registration) => {
      // Ausdrücklich nach einer neuen Fassung fragen.
      //
      // Ohne diese Zeile prüft der Browser von sich aus nur bei einer
      // Navigation zur Worker-Datei oder etwa alle 24 Stunden. Eine Seite,
      // die vollständig aus dem Cache kommt, erfährt von einem Deploy also
      // unter Umständen einen Tag lang nichts - und liefert so lange das alte
      // Bundle aus. Genau das ist am 07.09. passiert: Nach dem Austausch des
      // Google-Schlüssels lief im Browser weiter die Fassung mit dem alten
      // Wert, und die Karte wurde abgelehnt, obwohl der Server längst das
      // Richtige auslieferte.
      registration.update().catch(() => {
        /* ohne Netz nicht möglich - dann bleibt es beim nächsten Versuch */
      });

      // Ein Worker, der beim Laden schon wartet, ist eine bereits fertig
      // heruntergeladene neue Fassung - etwa weil der Nutzer den Hinweis
      // beim letzten Mal weggeklickt hat. Auch dann melden.
      if (registration.waiting && navigator.serviceWorker.controller) {
        config?.onUpdate?.(registration);
      }

      registration.onupdatefound = () => {
        const installing = registration.installing;
        if (!installing) return;

        installing.onstatechange = () => {
          if (installing.state !== 'installed') return;

          if (navigator.serviceWorker.controller) {
            // Es gab schon einen Worker: Das hier ist eine neue Fassung.
            config?.onUpdate?.(registration);
          } else {
            // Erster Durchlauf - ab jetzt funktioniert die Seite offline.
            config?.onSuccess?.(registration);
          }
        };
      };
    })
    .catch((error) => {
      console.error('[SW] Registrierung fehlgeschlagen:', error);
    });
}

function checkValidServiceWorker(swUrl, config) {
  // Auf localhost erst prüfen, ob es die Datei überhaupt gibt - sonst bliebe
  // ein alter Worker aus einem früheren Build hängen.
  fetch(swUrl, { headers: { 'Service-Worker': 'script' } })
    .then((response) => {
      const contentType = response.headers.get('content-type');
      if (response.status === 404 || (contentType && !contentType.includes('javascript'))) {
        navigator.serviceWorker.ready.then((registration) => {
          registration.unregister().then(() => window.location.reload());
        });
      } else {
        registerValidSW(swUrl, config);
      }
    })
    .catch(() => {
      console.log('[SW] Keine Verbindung - die App läuft im Offline-Modus.');
    });
}

export function unregister() {
  if (!('serviceWorker' in navigator)) return;
  navigator.serviceWorker.ready
    .then((registration) => registration.unregister())
    .catch((error) => console.error('[SW]', error));
}
